import {
  ADD_FINANCIAL_GROUPS,
  ADD_GROUP_MESSAGE_SETTINGS,
  ADD_KYC_ITEMS,
  ADD_STATISTICS,
  ADD_GIFT_CARD_SETTINGS,
  ADD_NETWORKS,
} from '../actions';
import {keyBy} from 'lodash';

const INIT_STATE = {
  statistics: null,
  giftCardSettings: null,
  financialGroups: [],
  groupMessageSettings: {},
  networks: {},
  kycItems: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_GIFT_CARD_SETTINGS:
      return {
        ...state,
        giftCardSettings: action.payload,
      };
    case ADD_GROUP_MESSAGE_SETTINGS:
      return {
        ...state,
        groupMessageSettings: {
          ...state.groupMessageSettings,
          [action.payload.type]: {
            ...action.payload,
            destinationCategories: keyBy(action.payload.destinationCategories, 'type'),
          },
        },
      };
    case ADD_STATISTICS:
      return {
        ...state,
        statistics: action.payload,
      };
    case ADD_FINANCIAL_GROUPS:
      return {
        ...state,
        financialGroups: action.payload,
      };
    case ADD_KYC_ITEMS:
      return {
        ...state,
        kycItems: action.payload,
      };
    case ADD_NETWORKS:
      return {
        ...state,
        networks: action.payload,
      };
    default:
      return {...state};
  }
};
